import { jsx as _jsx } from "react/jsx-runtime";
import { Menu, MenuItem, showContextMenu, } from '@blueprintjs/core';
export function ContextMenu(props) {
    const { options, onSelect, children, as: Wrapper = 'div', ...other } = props;
    function handleContextMenu(event) {
        if (!Array.isArray(options) || options.length === 0) {
            return;
        }
        const content = (_jsx(Menu, { children: options.map((option) => (_jsx(MenuItem, { ...option, onClick: () => onSelect(option?.data) }, JSON.stringify(option)))) }));
        event.preventDefault();
        showContextMenu({
            content,
            targetOffset: {
                left: event.clientX,
                top: event.clientY,
            },
        });
    }
    return (_jsx(Wrapper, { ...other, onContextMenu: handleContextMenu, children: children }));
}
